import { render, staticRenderFns } from "./AlertCard.vue?vue&type=template&id=0c6e747c&scoped=true"
import script from "./AlertCard.vue?vue&type=script&lang=js"
export * from "./AlertCard.vue?vue&type=script&lang=js"
import style0 from "./AlertCard.vue?vue&type=style&index=0&id=0c6e747c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6e747c",
  null
  
)

export default component.exports